(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Faq-collection-tab"] && !Shopify.designMode) return;
  try {
    
   document.addEventListener('DOMContentLoaded',()=>{const togglers=document.querySelectorAll('[data-toggle]');const tabLinks=document.querySelectorAll('.tab-link');const faqContainers=document.querySelectorAll('.faq-container');togglers.forEach((btn)=>{btn.addEventListener('click',(e)=>{const selector=e.currentTarget.dataset.toggle;const block=document.querySelector(`${selector}`);if(e.currentTarget.classList.contains('active')){block.style.maxHeight='';block.classList.remove('open')}else{block.style.maxHeight=block.scrollHeight+'px';block.classList.add('open')}
e.currentTarget.classList.toggle('active')})});tabLinks.forEach(link=>{link.addEventListener('click',(e)=>{e.preventDefault();const target=e.currentTarget.dataset.target;faqContainers.forEach(container=>{container.classList.remove('active')});document.querySelector(target).classList.add('active');tabLinks.forEach(tab=>{tab.classList.remove('active')});e.currentTarget.classList.add('active')})})})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-tab"] && !Shopify.designMode) return;
  try {
    
   document.addEventListener('DOMContentLoaded',()=>{const togglers=document.querySelectorAll('[data-toggle]');const tabLinks=document.querySelectorAll('.tab-link');const faqContainers=document.querySelectorAll('.faq-container');togglers.forEach((btn)=>{btn.addEventListener('click',(e)=>{const selector=e.currentTarget.dataset.toggle;const block=document.querySelector(`${selector}`);if(e.currentTarget.classList.contains('active')){block.style.maxHeight='';block.classList.remove('open')}else{block.style.maxHeight=block.scrollHeight+'px';block.classList.add('open')}
e.currentTarget.classList.toggle('active')})});tabLinks.forEach(link=>{link.addEventListener('click',(e)=>{e.preventDefault();const target=e.currentTarget.dataset.target;faqContainers.forEach(container=>{container.classList.remove('active')});document.querySelector(target).classList.add('active');tabLinks.forEach(tab=>{tab.classList.remove('active')});e.currentTarget.classList.add('active')})})})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collections-banner"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Handle section video
  const sectionVideo = document.getElementById('sectionBackgroundVideo');
  const sectionPoster = document.getElementById('sectionVideoPoster');
  
  if (sectionVideo) {
    // Hide video initially
    sectionVideo.style.opacity = '0';
    
    // Function to show video and hide poster
    const showVideo = () => {
      sectionVideo.style.opacity = '1';
      sectionVideo.classList.add('playing');
      if (sectionPoster) sectionPoster.classList.add('hidden');
      
      // Clean up event listeners
      sectionVideo.removeEventListener('canplay', showVideo);
      sectionVideo.removeEventListener('loadedmetadata', showVideo);
      sectionVideo.removeEventListener('progress', showVideo);
    };
    
    // Add event listeners
    sectionVideo.addEventListener('canplay', showVideo);
    sectionVideo.addEventListener('loadedmetadata', showVideo);
    sectionVideo.addEventListener('progress', function() {
      if (sectionVideo.readyState >= 3) {
        showVideo();
      }
    });
    
    // If video is already loaded
    if (sectionVideo.readyState >= 3) {
      showVideo();
    }
    
    // Handle video errors
    sectionVideo.addEventListener('error', function() {
      console.error('Section video failed to load');
      if (sectionPoster) sectionPoster.classList.remove('hidden');
    });
  }

  // Handle block videos
  const blockVideos = document.querySelectorAll('.videoBackgroundFile:not(#sectionBackgroundVideo)');
  
  blockVideos.forEach(video => {
    // Hide video initially
    video.style.opacity = '0';
    
    // Find closest poster image
    const poster = video.closest('.featured-collections-banner-img')?.querySelector('.video-poster');
    
    // Function to show video and hide poster
    const showBlockVideo = () => {
      video.style.opacity = '1';
      video.classList.add('playing');
      if (poster) poster.classList.add('hidden');
      
      // Clean up event listeners
      video.removeEventListener('canplay', showBlockVideo);
      video.removeEventListener('loadedmetadata', showBlockVideo);
    };
    
    // Add event listeners
    video.addEventListener('canplay', showBlockVideo);
    video.addEventListener('loadedmetadata', showBlockVideo);
    
    // If video is already loaded
    if (video.readyState >= 3) {
      showBlockVideo();
    }
    
    // Handle video errors
    video.addEventListener('error', function() {
      console.error('Block video failed to load');
      if (poster) poster.classList.remove('hidden');
    });
  });

  // Performance optimization script for lazy loading
  const lazyMedia = document.querySelectorAll('.lazy-media');
  
  // Load media on hover
  document.querySelectorAll('[data-hover-collection-item]').forEach(item => {
    item.addEventListener('mouseenter', function() {
      const mediaId = this.dataset.media;
      const mediaElement = document.getElementById(mediaId);
      if (!mediaElement) return;
      
      const lazyElement = mediaElement.querySelector('.lazy-media');
      if (!lazyElement || lazyElement.dataset.loaded) return;
      
      const mediaType = lazyElement.dataset.type;
      
      if (mediaType === 'video' && lazyElement.dataset.video) {
        lazyElement.innerHTML = lazyElement.dataset.video;
        const video = lazyElement.querySelector('video');
        if (video) {
          video.setAttribute('autoplay', 'true');
          video.setAttribute('muted', 'true');
          video.setAttribute('loop', 'true');
          video.setAttribute('playsinline', 'true');
        }
      } 
      else if (mediaType === 'image' && lazyElement.dataset.image) {
        lazyElement.innerHTML = `<img src="${lazyElement.dataset.image}" loading="lazy" alt="Collection image">`;
      }
      
      lazyElement.dataset.loaded = true;
    });
  });

  // Add global video control hiding
  const style = document.createElement('style');
  style.textContent = `
    video::-webkit-media-controls {
      display: none !important;
    }
    video::-webkit-media-controls-enclosure {
      display: none !important;
    }
    video::-webkit-media-controls-panel {
      display: none !important;
    }
    video::-webkit-media-controls-play-button {
      display: none !important;
    }
    video::-webkit-media-controls-timeline {
      display: none !important;
    }
    video::-webkit-media-controls-current-time-display {
      display: none !important;
    }
    video::-webkit-media-controls-time-remaining-display {
      display: none !important;
    }
  `;
  document.head.appendChild(style);
});

  } catch(e) { console.error(e); }
})();
})();
